export default __webpack_public_path__ + "fonts/Fabrik-Bold.woff2";